module.exports = __webpack_public_path__ + "static/img/head.616e0fb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/head.jpeg
// module id = TTuh
// module chunks = 167